import { AppHubCard } from "@/components/common/AppHubCard";
import { AppHubPage } from "@/components/common/AppHubPage";
import { useNav } from "@/utils/nav";
import { ui } from "@patient-watch/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Activity, Server, UserRoundSearch } from "lucide-react";
import { useState } from "react";

const developerItems = [
    {
        title: "Operations",
        description: "Health checks, reminder send volume, and SMS delivery.",
        icon: <Activity className="w-7 h-7 text-white" />,
        iconBg: "bg-gradient-to-br from-sky-500 to-sky-600",
        bgGradient: "bg-gradient-to-br from-sky-50 to-sky-50",
        hoverOverlay: "before:bg-gradient-to-br before:from-sky-100/50 before:to-sky-200/50",
        borderColor: "border-sky-200 hover:border-sky-300",
        primaryButtonClassName: "bg-sky-600 hover:bg-sky-700",
        links: [
            { to: "/developer/health-check", label: "Health check" },
            { to: "/developer/reminder-send-volume", label: "Reminder send volume" },
            { to: "/developer/sms-deliverability", label: "SMS issues" },
        ],
    },
    {
        title: "Report delivery",
        description: "NHS report uploads, organisation folders, and manual diary PDF delivery.",
        icon: <Server className="w-7 h-7 text-white" />,
        iconBg: "bg-gradient-to-br from-cyan-500 to-cyan-600",
        bgGradient: "bg-gradient-to-br from-cyan-50 to-cyan-50",
        hoverOverlay: "before:bg-gradient-to-br before:from-cyan-100/50 before:to-cyan-200/50",
        borderColor: "border-cyan-200 hover:border-cyan-300",
        primaryButtonClassName: "bg-cyan-600 hover:bg-cyan-700",
        links: [
            { to: "/developer/sftp/diaries", label: "Diaries" },
            { to: "/developer/sftp/organisations", label: "Organisations" },
            { to: "/developer/sftp/upload", label: "Upload" },
        ],
    },
    {
        title: "Developer tools",
        description: "Open an entry by id for debugging.",
        icon: <UserRoundSearch className="w-7 h-7 text-white" />,
        iconBg: "bg-gradient-to-br from-rose-500 to-rose-600",
        bgGradient: "bg-gradient-to-br from-rose-50 to-rose-50",
        hoverOverlay: "before:bg-gradient-to-br before:from-rose-100/50 before:to-rose-200/50",
        borderColor: "border-rose-200 hover:border-rose-300",
        isToolsCard: true,
        primaryButtonClassName: "bg-rose-600 hover:bg-rose-700",
    },
];

function DeveloperToolsFooter() {
    const navigate = useNavigate();
    const [entryId, setEntryId] = useState("");

    return (
        <>
            <ui.Input
                placeholder="Entry UUID"
                value={entryId}
                onChange={(event) => setEntryId(event.target.value.trim())}
            />
            <ui.Button
                size="md"
                className="bg-rose-600 hover:bg-rose-700 w-full"
                disabled={!entryId}
                onClick={() =>
                    navigate({
                        to: "/admin/entry/$entryId",
                        params: { entryId },
                    })
                }
            >
                Open entry debugger
            </ui.Button>
        </>
    );
}

const DeveloperPage = () => {
    useNav([{ label: "Developer", route: { to: "/developer" } }]);

    const developerToolsCard = developerItems.find((item) => item.isToolsCard);

    return (
        <AppHubPage
            title="Developer"
            description="Operations, report delivery, and debugging tools for building Patient Watch."
        >
            {developerItems
                .filter((item) => !item.isToolsCard)
                .map((item) => (
                    <AppHubCard key={item.title} {...item} />
                ))}

            {developerToolsCard && <AppHubCard {...developerToolsCard} footer={<DeveloperToolsFooter />} />}
        </AppHubPage>
    );
};

export const Route = createFileRoute("/_app/developer/")({
    component: DeveloperPage,
});
